"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Usergroup = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const package_1 = require("../package");
const sioc_1 = require("../ontologies/sioc");
const UserAccount_1 = require("./UserAccount");
const Space_1 = require("./Space");
let Usergroup = class Usergroup extends Shape_1.Shape {
    get members() {
        return this.getAllAs(sioc_1.sioc.has_member, UserAccount_1.UserAccount);
    }
    get spaces() {
        return this.getAllAs(sioc_1.sioc.usergroup_of, Space_1.Space);
    }
};
Usergroup.targetClass = sioc_1.sioc.Usergroup;
Usergroup = __decorate([
    package_1.linkedShape
], Usergroup);
exports.Usergroup = Usergroup;
//# sourceMappingURL=Usergroup.js.map